import React, {Component} from 'react';
import countBy from 'lodash.countby';

import {Edit} from 'components/detail';
import {SimpleForm} from 'components/form';
import Toolbar from 'components/form/Toolbar';
import {SaveButton} from 'components/button';
import {DateInput, SelectInput, TextInput} from 'components/input';

import {DisabledInputOptions, InputOptions} from 'util/constants';
import {AppTypeChoices, ExtendInputOptions, getDateBefore} from './utils'
import {connect} from "react-redux";

class ShopPushDeviceListBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app_type: 0,
      start_time: '',
      end_time: '',
    };
    this.minDate = getDateBefore(89);
    this.maxDate = getDateBefore(0);
  };
  
  appTypeOnChange = (_, value) => {
    this.setState({app_type: value});
  };
  startTimeOnChange = (_, value) => {
    this.setState({start_time: value});
  };
  endTimeOnChange = (_, value) => {
    this.setState({end_time: value});
  };
  
  render() {
    const TotalDeviceField = ({record = {}}) =>
      <span><strong>
        {countBy(record.device_push_list, (d) => d.app_type)[this.state.app_type] || 0} devices
      </strong></span>;
    
    const DeviceDetailField = ({record = {}}) => <div>{
      (!record.device_push_list) ? <div></div> :
        record.device_push_list.map(device => {
          return device.app_type === this.state.app_type &&
            <p key={device.device_id}>{device.device_id} - {device.device_name}</p>
        })
    }
    </div>;
    
    return (
      <Edit
        {...this.props}
      >
        <SimpleForm
          toolbar={(
            <Toolbar>
              <SaveButton
                label="Get Log"
              />
            </Toolbar>
          )}
        >
          <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
          <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
          <DateInput options={InputOptions} source="start_time" label="Start Date" onChange={this.startTimeOnChange}
                     minDate={this.minDate} maxDate={this.maxDate} isRequired={true}/>
          <DateInput options={InputOptions} source="end_time" label="End Date" onChange={this.endTimeOnChange}
                     minDate={this.minDate} maxDate={this.maxDate} isRequired={true}/>
          <SelectInput options={ExtendInputOptions} label="App Type" source="app_type" choices={AppTypeChoices}
                       onChange={this.appTypeOnChange} isRequired={true}
          />
          <TotalDeviceField/>
          <DeviceDetailField/>
        
        </SimpleForm>
      </Edit>
    );
  }
}

export const ShopPushDeviceList = connect()(ShopPushDeviceListBase);


// WEBPACK FOOTER //
// ./src/routes/shop/ShopPushDeviceList.js